
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const Terms = lazy(() => import('../pages/terms/page'));
const Presentation = lazy(() => import('../pages/presentation/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/terms',
    element: <Terms />
  },
  {
    path: '/presentation',
    element: <Presentation />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
